// extracted by mini-css-extract-plugin
export default {"centerContent":"ZGAqtNe95sJaYRYHHKna","chatOpen":"Og9eEBZe_zcJ9_FgQlNz"};